import axios from 'axios';
import {API_URL} from '../utils/constants.js';

class StaticPageService {
    async getStaticPage(permalink) {
        const url = `${API_URL}get-static-page/${permalink}/`;
        const headers = {
            'Content-Type':'multipart/form-data',
            'Access-Control-Allow-Origin':'*'

        }
        return axios({
            url:url,
            method: 'get',
            crossDomain:true,
            config:{headers:headers},
            //headers: {'Access-Control-Allow-Origin': '*'}
        }).then(function(response) {
            return response;
        }).catch(function(response) {
            return response;
        });
    }
}

export default StaticPageService;